export default "__VITE_ASSET__DrDt7qCX__"